import ReactUseWebSocket from 'react-use-websocket';
import type { Options, WebSocketHook } from 'react-use-websocket/dist/lib/types';

const rawUseWebSocket = (ReactUseWebSocket as any).default || ReactUseWebSocket;

export const useWebSocket = rawUseWebSocket as <T = unknown>(
  url: string | (() => string | Promise<string>) | null,
  options?: Options,
  connect?: boolean
) => WebSocketHook<T>;

export { ReadyState } from 'react-use-websocket';
export type { SendMessage, Options, WebSocketHook } from 'react-use-websocket/dist/lib/types';
